import { lazy } from 'react';
import { overviewRoutes } from './overviewRoutes';
import { starsMonitorPeerAnalysisRoutes } from './starsMonitorPeerAnalysisRoutes';

const QiOpportunityMeasureAnalysis = lazy(() =>
  import('../pages/qiOpportunityMeasureAnalysis/QiOpportunityMeasureAnalysis')
);
const ProjectedResults = lazy(() => import('../pages/projectedResults/ProjectedResults'));
const Pp1qa = lazy(() => import('../pages/pp1qa/Pp1qaLayout'));

const QiRiskMeasureAnalysis = lazy(() => import('../pages/qiRiskMeasureAnalysis/QiRiskMeasureAnalysis'));

const AccumenPerformanceTracking = lazy(() => import('../accumenPerformanceTracking'));

const ClientDataUploader = lazy(() => import('../clientDataUploader'));

const CurrentMonthAlertsUpdated = lazy(() => import('../currentMonthAlertsUpdated'));

const IndividualCutpointAnalysisUpdated = lazy(() => import('../cutpointAnalysisUpdated'));

const ExecutiveSummaryUpdated = lazy(() => import('../executiveSummaryUpdated'));

const FocusMeasureAnalysis = lazy(() => import('../focusMeasureAnalysis'));

const HEIDetails = lazy(() => import('../pages/heiDetails/heiDetails.js'));

const HomeDashboard = lazy(() => import('../homeDashboard'));

const IndividualMeasureAnalysis = lazy(() => import('../individualMeasureAnalysis'));

const MedaliaMetricAnalysis = lazy(() => import('../medaliaPerformanceAnalysis'));

const MonthlyMeasureSetReview = lazy(() => import('../pages/monthlyMeasureSetReview/MonthlyMeasureSetReview'));

const MultiContractMeasureAnalysis = lazy(() =>
  import('../pages/multiContractMeasureAnalysis/MultiContractMeasureAnalysis')
);

const MultiContractQI = lazy(() => import('../multiContractQI.js'));

const MultContractTrendAnalysis = lazy(() => import('../pages/multiContractTrendAnalysis/MultiContractTrendAnalysis'));

const MultiContractUnderPerformanceUpdate = lazy(() => import('../multiContractUnderPerformanceUpdate'));

const Overview = lazy(() => import('../overviewPage'));

const PartCDAnalysis = lazy(() => import('../pages/partCDAnalysis/PartCDAnalysis'));

const PerformanceScorecardUpdated = lazy(() => import('../performanceScoreCardUpdated'));

const HedisPerformanceAnalysis = lazy(() => import('../pages/hedisPerformanceAnalysis/HedisPerformanceAnalysis'));
const PharmacyPerformanceAnalysis = lazy(() =>
  import('../pages/pharmacyPerformanceAnalysis/PharmacyPerformanceAnalysis')
);
const OperationsPerformanceAnalysis = lazy(() => import('../operationsPerformanceAnalysis'));
const CAHPSPerformanceAnalysis = lazy(() => import('../cahpsPerformanceAnalysis'));

const HOSPerformanceAnalysis = lazy(() => import('../hosPerformanceAnalysis'));
const QIGlidePath = lazy(() => import('../qiGlidePath'));
const RewardFactorTargeting = lazy(() => import('../pages/rewardFactorTargeting/RewardFactorTargeting'));

const PerformanceAnalysis = lazy(() => import('../pages/performanceAnalysis/PerformanceAnalysisLayout'));

const RechartTest = lazy(() => import('../rechartTest'));

const RewardFactorOverview = lazy(() => import('../pages/rewardFactorOverview/RewardFactorOverview'));

const RFQIOptimization = lazy(() => import('../pages/rfQiOptimization/RFQIOptimization'));

const RiskOpportunitySummary = lazy(() => import('../riskOpportunitySummary'));

const ScenarioModeler = lazy(() => import('../scenarioModeler'));

const VendorScenarioModeler = lazy(() => import('../scenarioModelerVendor'));

const ScorecardDirectory = lazy(() => import('../scorecardDirectory'));

const StarsComponentBreakdown = lazy(() => import('../starComponentBreakdown'));

const TargetRefinementSessions = lazy(() => import('../pages/targetRefinementSessions/TargetRefinementSessions'));

const TrendVsNatlAvg = lazy(() => import('../trendVsNationalAverage'));

const TukeyRiskAnalysis = lazy(() => import('../tukeyRiskAnalysis'));

const QiExplained = lazy(() => import('../pages/qiExplained/QiExplained'));

const YearEndProjectionAnalysisViewTwo = lazy(() =>
  import('../pages/yearEndProjectionAnalysisViewTwo/YearEndProjectionAnalysisViewTwo.js')
);

const MonthlyMeasurePerformanceSummary = lazy(() =>
  import('../pages/monthlyMeasurePerformanceSummary/MonthlyMeasurePerformanceSummary')
);

const OpportunityAndRiskMeasures = lazy(() => import('../pages/opportunityAndRiskMeasures/OpportunityAndRiskMeasures'));
const PDFPerformanceReview = lazy(() => import('../pages/pdfPerformanceReview/PDFPerformanceReviw'));

const WeeklyInividualMeasureAnalysis = lazy(() =>
  import('../pages/weeklyIndividualMeasureAnalysis/WeeklyIndividualMeasureAnalysis')
);

const HistoricalWeeklyPerformance = lazy(() =>
  import('../pages/historicalWeeklyPerformance/HistoricalWeeklyPerformance')
);

const WeeklyPerformanceChanges = lazy(() => import('../pages/weeklyPerformanceChanges/WeeklyPerformanceChanges.jsx'));

const WeeklyPerformanceReview = lazy(() => import('../pages/weeklyPerformanceReview/WeeklyPerformanceReview.jsx'));

const WeeklyDownloadable = lazy(() => import('../pages/weeklyDownloadable/WeeklyDownloadable.jsx'));
const weeklyGrievanceReport = lazy(() => import('../pages/weeklyGrievanceReport/WeeklyGrievanceReport.jsx'));

const HedisGapClosureAnalysis = lazy(() => import('../pages/hedisGapClosureAnalysis/HedisGapClosureAnalysis'));
const RewardFactorHistoricalThresholds = lazy(() =>
  import('../pages/rewardFactorHistoricalThresholds/RewardFactorHistoricalThresholds')
);
const HistoricalTrendAnalysis = lazy(() => import('../pages/historicalTrendAnalysis/HistoricalTrendAnalysis'));
const TrendPerformanceVsNationalAverage = lazy(() =>
  import('../pages/trendPerformanceVsNationalAverage/TrendPerformanceVsNationalAverage')
);
const QualityBonusPayment = lazy(() => import('../pages/qualityBonusPayment/QualityBonusPayment'));

const ScenarioComparison = lazy(() => import('../pages/scenarioComparision/ScenarioComparision'));

const Crosswalk = lazy(() => import('../pages/crosswalk/CrosswalkLayout'));

const OpportunityByState = lazy(() => import('../pages/opportunityByState/OpportunityByState'));

const CurrentProjections = lazy(() => import('../pages/currentProjections/CurrentProjections'));

//if adding a page that uses the Overview component, add it to the overviewRoutes array if everyone should be able to access it
export const starsMonitorRoutes = [
  {
    path: '/',
    component: ScorecardDirectory,
    menuType: 'quickLinks',
  },
  {
    path: '/directory',
    component: ScorecardDirectory,
    menuType: 'quickLinks',
  },
  {
    path: '/opportunityByState',
    component: OpportunityByState,
    menuType: 'quickLinks',
  },
  {
    path: '/currentProjections',
    component: CurrentProjections,
    menuType: 'quickLinks',
  },
  {
    path: '/executiveSummary',
    component: ExecutiveSummaryUpdated,
    menuType: 'monthlyStars',
  },
  {
    path: '/rewardFactorHistoricalThresholds',
    component: RewardFactorHistoricalThresholds,
    menuType: '',
  },
  {
    path: '/qualityBonusPayment',
    component: QualityBonusPayment,
    menuType: '',
  },
  {
    path: '/trendPerformanceVsNationalAverage',
    component: TrendPerformanceVsNationalAverage,
    menuType: '',
  },
  {
    path: '/hedisGapClosureAnalysis',
    component: HedisGapClosureAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/pp1qa',
    component: Pp1qa,
    menuType: 'monthlyStars',
  },
  {
    path: '/projectedResults',
    component: ProjectedResults,
    menuType: 'monthlyStars',
  },
  {
    path: '/crosswalk',
    component: Crosswalk,
    menuType: '',
  },
  {
    path: '/performanceAnalysis',
    component: PerformanceAnalysis,
    menuType: 'monthlyStars',
  },
  {
    path: '/scenarioComparison',
    component: ScenarioComparison,
    menuType: 'monthlyStars',
  },
  {
    path: '/qiExplained',
    component: QiExplained,
    menuType: 'leadershipPackage',
  },
  {
    path: '/chartTest',
    component: RechartTest,
    menuType: 'multiContractViews',
  },
  {
    path: '/home',
    component: HomeDashboard,
    menuType: 'monthlyStars',
  },
  {
    path: '/tukeyRiskAnalysis',
    component: TukeyRiskAnalysis,
    menuType: 'monthlyStars',
  },

  {
    path: '/multiContractMeasureAnalysis',
    component: MultiContractMeasureAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/multiContractTrendAnalysis',
    component: MultContractTrendAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/performanceScorecard',
    component: PerformanceScorecardUpdated,
    menuType: 'monthlyStars',
  },
  {
    path: '/executiveSummary',
    component: ExecutiveSummaryUpdated,
    menuType: 'monthlyStars',
  },
  {
    path: '/currentMonthAlerts',
    component: CurrentMonthAlertsUpdated,
    menuType: 'measureChampion',
  },
  {
    path: '/monthlyMeasurePerformanceSummary',
    component: MonthlyMeasurePerformanceSummary,
    menuType: 'monthlyStars',
  },
  {
    path: '/opportunityAndRiskMeasures',
    component: OpportunityAndRiskMeasures,
    menuType: 'monthlyStars',
  },
  {
    path: '/MultiContractUnderPerformance',
    component: MultiContractUnderPerformanceUpdate,
    menuType: 'multiContractViews',
  },
  {
    path: '/OrgWideUnderPerformance',
    component: MultiContractUnderPerformanceUpdate,
    menuType: 'multiContractViews',
  },
  {
    path: '/MultiContractQI',
    component: MultiContractQI,
    menuType: 'leadershipPackage',
  },
  {
    path: '/cutpointAnalysis',
    component: IndividualCutpointAnalysisUpdated,
    menuType: 'quickLinks',
  },
  {
    path: '/MonthlyMeasureSetReview',
    component: MonthlyMeasureSetReview,
    menuType: 'additionalAnalysis',
  },
  {
    path: '/rfQIOptimization',
    component: RFQIOptimization,
    menuType: 'monthlyStars',
  },
  {
    path: '/rewardFactorOverview',
    component: RewardFactorOverview,
    menuType: 'rewardFactor',
  },
  {
    path: '/rewardFactorTargeting',
    component: RewardFactorTargeting,
    menuType: 'rewardFactor',
  },
  {
    path: '/partCDAnalysis',
    component: PartCDAnalysis,
    menuType: 'leadershipPackage',
  },

  {
    path: '/individualMeasureAnalysis',
    component: IndividualMeasureAnalysis,
    menuType: 'monthlyStars',
  },
  {
    path: '/targetRefinementSessions',
    component: TargetRefinementSessions,
    menuType: 'monthlyStars',
  },
  {
    path: '/historicalTrendAnalysis',
    component: HistoricalTrendAnalysis,
    menuType: 'additionalAnalysis',
  },
  {
    path: '/trendVsNational',
    component: TrendVsNatlAvg,
    menuType: 'additionalAnalysis',
  },
  {
    path: '/starsComponentBreakdown',
    component: StarsComponentBreakdown,
    menuType: 'additionalAnalysis',
  },
  {
    path: '/uploader',
    component: ClientDataUploader,
    menuType: 'measureChampion',
  },
  {
    path: '/accumentPerformanceTracking',
    component: AccumenPerformanceTracking,
    menuType: 'measureChampion',
  },
  {
    path: '/hedisPerformanceAnalysis',
    component: HedisPerformanceAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/cahpsPerformanceAnalysis',
    component: CAHPSPerformanceAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/operationsPerformanceAnalysis',
    component: OperationsPerformanceAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/pharmacyPerformanceAnalysis',
    component: PharmacyPerformanceAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/HOSPerformanceAnalysis',
    component: HOSPerformanceAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/yearEndProjectionAnalysisViewTwo',
    component: YearEndProjectionAnalysisViewTwo,
    menuType: 'monthlyStars',
  },
  {
    path: '/medaliaMetricAnalysis',
    component: MedaliaMetricAnalysis,
    menuType: 'measureChampion',
  },
  {
    path: '/scenarioModeler',
    component: ScenarioModeler,
    menuType: 'monthlyStars',
  },
  {
    path: '/vendorScenarioModeler',
    component: VendorScenarioModeler,
    menuType: 'monthlyStars',
  },
  {
    path: '/riskOpportunitySummary',
    component: RiskOpportunitySummary,
    menuType: 'monthlyStars',
  },
  {
    path: '/focusMeasureAnalysis',
    component: FocusMeasureAnalysis,
    menuType: 'monthlyStars',
  },
  {
    path: '/qiglidepath',
    component: QIGlidePath,
    menuType: 'monthlyStars',
  },
  {
    path: '/heiDetails',
    component: HEIDetails,
    menuType: 'measureChampion',
  },
  {
    path: '/qiRiskMeasureAnalysis',
    component: QiRiskMeasureAnalysis,
    menuType: 'qualityImprovement',
  },
  {
    path: '/qiOpportunityMeasureAnalysis',
    component: QiOpportunityMeasureAnalysis,
    menuType: 'qualityImprovement',
  },
  {
    path: '/directory',
    component: ScorecardDirectory,
    menuType: 'quickLinks',
  },
  {
    path: '/performanceReview',
    component: PDFPerformanceReview,
    menuType: 'quickLinks',
  },
  {
    path: '/pdfperformanceReview',
    component: PDFPerformanceReview,
    menuType: 'quickLinks',
  },
  {
    path: '/weeklyPerformanceReview',
    component: WeeklyPerformanceReview,
    menuType: 'weeklyRedFlagAnalysis',
  },
  {
    path: '/weeklyPerformanceChanges',
    component: WeeklyPerformanceChanges,
    menuType: 'weeklyRedFlagAnalysis',
  },
  {
    path: '/weeklyIndividualMeasureAnalysis',
    component: WeeklyInividualMeasureAnalysis,
    menuType: 'weeklyRedFlagAnalysis',
  },
  {
    path: '/historicalWeeklyPerformance',
    component: HistoricalWeeklyPerformance,
    menuType: 'weeklyRedFlagAnalysis',
  },
  {
    path: '/weeklyDownloadable',
    component: WeeklyDownloadable,
    menuType: 'weeklyRedFlagAnalysis',
  },
  {
    path: '/weeklyGrievanceReport',
    component: weeklyGrievanceReport,
    menuType: 'weeklyRedFlagAnalysis',
  },
  ...overviewRoutes,
  ...starsMonitorPeerAnalysisRoutes,
  {
    //catch all
    path: '*',
    component: ScorecardDirectory,
    menuType: 'quickLinks',
  },
];
